



























































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { IdentitasPasien } from "@/types";
import { storeDokter } from "@/store/modules/dokter";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import SvcPersetujuanTransfusiDarah from "@/services/PersetujuanTransfusiDarah";
import StorePersetujuanTransfusiDarah from "@/store/modules/PersetujuanTransfusiDarah";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { prefillRuangRawat } from "@/utils/prefillBangsalKelas";
import { localISODate, parseLocalDate } from "@/utils/localDate";
import { opsiBagianPenyakit } from "./persetujuanLayananDarah";

@Component({
  components: { VCDateTimePicker, UnitRuangPicker },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class PersetujuanTransfusiDarahInputCard extends Vue {
  get opsiBagian(): string[] {
    return opsiBagianPenyakit(this.bagian_penyakit);
  }

  @Prop() readonly register!: string;
  @Prop() dataSuket!: any;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = false;
  saving = false;

  requiredRule = [v => !!v || "*Kolom ini harus diisi"];
  hariIni = moment()
    .endOf("day")
    .toDate();

  jenisKelaminOptions = ["L", "P"];
  golonganDarahOptions = ["A", "B", "O", "AB"];

  hubunganOptions = [
    { value: "diri_sendiri", text: "Diri Sendiri" },
    { value: "istri", text: "Istri" },
    { value: "suami", text: "Suami" },
    { value: "anak", text: "Anak" },
    { value: "ibu", text: "Ibu" },
    { value: "ayah", text: "Ayah" }
  ];

  checklistItems = [
    { key: "tujuan_indikasi", label: "Tujuan / Indikasi tindakan transfusi darah" },
    { key: "jenis_komponen", label: "Jenis komponen dan perkiraan jumlah darah yang diberikan" },
    { key: "risiko_komplikasi", label: "Risiko dan komplikasi yang mungkin terjadi (termasuk resiko infeksi HIV, Hepatitis B, Hepatitis C, Virus Hepatitis lainnya, Sifilis, Malaria, dan penyakit lainnya)" },
    { key: "tindakan_luar_dugaan", label: "Tindakan lain yang diberikan jika dokter menemukan sesuatu yang diluar dugaan" },
    { key: "hasil_tidak_sesuai", label: "Tindakan ini bisa memberikan hasil yang tidak sesuai harapan meskipun sudah dilakukan sesuai prosedur yang berlaku" },
    { key: "kondisi_darurat", label: "Dalam kondisi kritis/darurat (emergency) transfusi dapat diberikan tanpa menunggu hasil Cross Test darah" }
  ];

  is_diri_sendiri = this.dataSuket?.content?.is_diri_sendiri ?? true;

  pembuat = {
    nama: this.dataSuket?.content?.pembuat_pernyataan?.nama || (this.is_diri_sendiri ? this.pasien.nama : ""),
    umur: this.dataSuket?.content?.pembuat_pernyataan?.umur || (this.is_diri_sendiri ? this.pasienUmur : ""),
    jenis_kelamin: this.dataSuket?.content?.pembuat_pernyataan?.jenis_kelamin || (this.is_diri_sendiri ? this.pasien.jk : ""),
    nik: this.dataSuket?.content?.pembuat_pernyataan?.nik || (this.is_diri_sendiri ? (this.pasien.nik || "") : ""),
    alamat: this.dataSuket?.content?.pembuat_pernyataan?.alamat || (this.is_diri_sendiri ? this.pasien.alamat : ""),
    telepon: this.dataSuket?.content?.pembuat_pernyataan?.telepon || (this.is_diri_sendiri ? (this.pasien.telp || "") : ""),
    hubungan: this.dataSuket?.content?.pembuat_pernyataan?.hubungan || (this.is_diri_sendiri ? "diri_sendiri" : "")
  };

  golongan_darah = this.dataSuket?.content?.golongan_darah || "";
  bagian_penyakit = this.dataSuket?.content?.bagian_penyakit || "";
  ruang_rawat =
    this.dataSuket?.content?.ruang_rawat ||
    (this.dataSuket ? "" : prefillRuangRawat(RegisterKunjungan.register, this.register));

  checklist = {
    tujuan_indikasi: this.dataSuket?.content?.checklist?.tujuan_indikasi || false,
    jenis_komponen: this.dataSuket?.content?.checklist?.jenis_komponen || false,
    risiko_komplikasi: this.dataSuket?.content?.checklist?.risiko_komplikasi || false,
    tindakan_luar_dugaan: this.dataSuket?.content?.checklist?.tindakan_luar_dugaan || false,
    hasil_tidak_sesuai: this.dataSuket?.content?.checklist?.hasil_tidak_sesuai || false,
    kondisi_darurat: this.dataSuket?.content?.checklist?.kondisi_darurat || false
  };

  saksi_1 = this.dataSuket?.content?.saksi_1 || "";
  saksi_2 = this.dataSuket?.content?.saksi_2 || "";
  tanggal_persetujuan = this.dataSuket?.content?.tanggal_persetujuan
    ? moment(this.dataSuket.content.tanggal_persetujuan).toDate()
    : new Date();
  signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
  creator_user_id = this.dataSuket?.creator_user_id || this.user.id;
  surat_date = this.dataSuket?.surat_date || moment().format("YYYY-MM-DD");

  get suratDate(): Date | null {
    return parseLocalDate(this.surat_date);
  }

  set suratDate(val: Date | null) {
    this.surat_date = val ? localISODate(val) : "";
  }

  get pasien(): Partial<IdentitasPasien> {
    return storePasien.identitasPasien || {};
  }

  get pasienUmur() {
    return this.pasien.tgl_lahir ? getAge(formatDMYDate(this.pasien.tgl_lahir)) : "";
  }

  get user() {
    return userModule.user;
  }

  get canSave(): boolean {
    if (this.readOnly) return false;
    const action = this.dataSuket ? "edit" : "create";
    return userModule.canAccessForm("persetujuan_transfusi_darah", action);
  }

  get listDokter() {
    return storeDokter.list;
  }

  get input() {
    return {
      register_id: this.dataSuket?.register_id || this.register,
      pasien_rm: this.dataSuket?.pasien_rm || this.pasien.rm,
      unit_id: this.dataSuket?.unit_id || this.user.unit_id,
      content: {
        is_diri_sendiri: this.is_diri_sendiri,
        pembuat_pernyataan: {
          nama: this.pembuat.nama,
          umur: this.pembuat.umur,
          jenis_kelamin: this.pembuat.jenis_kelamin,
          nik: this.pembuat.nik,
          alamat: this.pembuat.alamat,
          telepon: this.pembuat.telepon,
          hubungan: this.pembuat.hubungan
        },
        golongan_darah: this.golongan_darah,
        bagian_penyakit: this.bagian_penyakit,
        ruang_rawat: this.ruang_rawat,
        checklist: this.checklist,
        saksi_1: this.saksi_1,
        saksi_2: this.saksi_2,
        tanggal_persetujuan: this.tanggal_persetujuan
          ? moment(this.tanggal_persetujuan).format("YYYY-MM-DD HH:mm:ss")
          : null
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  onDiriSendiriChange(val: boolean) {
    if (val) {
      this.pembuat.nama = this.pasien.nama;
      this.pembuat.umur = this.pasienUmur;
      this.pembuat.jenis_kelamin = this.pasien.jk;
      this.pembuat.nik = this.pasien.nik || "";
      this.pembuat.alamat = this.pasien.alamat;
      this.pembuat.telepon = this.pasien.telp || "";
      this.pembuat.hubungan = "diri_sendiri";
    } else {
      this.pembuat.nama = "";
      this.pembuat.umur = "";
      this.pembuat.jenis_kelamin = "";
      this.pembuat.nik = "";
      this.pembuat.alamat = "";
      this.pembuat.telepon = "";
      this.pembuat.hubungan = "";
    }
  }

  save() {
    if (this.readOnly) return;
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? SvcPersetujuanTransfusiDarah.update(this.dataSuket.id, this.input)
        : SvcPersetujuanTransfusiDarah.create(this.input);

      action
        .then(() => {
          appModule.NoticeDelay("Berhasil Simpan Persetujuan Transfusi Darah");
          this.close();
          StorePersetujuanTransfusiDarah.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");
  }
}
